import { render, staticRenderFns } from "./LegalBasesAccepted.vue?vue&type=template&id=047a5fb7&"
import script from "./LegalBasesAccepted.vue?vue&type=script&lang=js&"
export * from "./LegalBasesAccepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports